import React, { useState, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { tokenVar } from '../../../providers/token.service';
import { ITextViewerProps } from './document-viewer-modal.types';

export const TextViewer: React.FC<ITextViewerProps> = ({ url }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const Authorization = useReactiveVar(tokenVar);

  useEffect(() => {
    const fetchTextContent = async () => {
      try {
        setLoading(true);
        setError(null);

        // Include authorization header if available (for API endpoints)
        const headers: HeadersInit = {};
        if (Authorization && url.includes('/api/')) {
          headers.Authorization = Authorization;
        }

        const response = await fetch(url, { headers });
        if (!response.ok) {
          throw new Error('Failed to load file');
        }
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load file');
      } finally {
        setLoading(false);
      }
    };

    fetchTextContent();
  }, [url, Authorization]);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-gray-500">Loading file...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="w-full max-h-[80vh] overflow-auto p-4">
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <pre className="text-sm font-mono whitespace-pre-wrap break-words">
          {content}
        </pre>
      </div>
    </div>
  );
};
